import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button';
import Dialog, {
	DialogContent,
	DialogFooter,
	DialogTop
} from '@/components/DialogSheet';
import { useIsTrialing } from '@/hooks/user';
import routes from '@/routes';
import { setIsModalTimerOpen } from '@/store/myDocuments';

function ModalTimer() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const isTrialing = useIsTrialing();
	const open = useSelector(state => state.myDocuments.isModalTimerOpen);

	const handleOpenChange = value => dispatch(setIsModalTimerOpen(value));
	const handleClose = () => handleOpenChange(false);

	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogContent className="w-full p-0 sm:w-[397px]">
				<DialogTop
					className="font-sans text-sm leading-6"
					description={t('myDocuments.timerDescription')}
					title={t('myDocuments.timerTitle')}
				/>
				<div className="px-9 py-9">
					<p className="text-center text-sm leading-6 text-gray-500">
						{t('myDocuments.timerDescription')}
					</p>
				</div>
				<DialogFooter className="flex justify-between">
					<Button
						className="w-full"
						onClick={handleClose}
						type="button"
						variant="outline"
					>
						{t('common.cancel')}
					</Button>
					<Button
						className="w-full"
						onClick={() => {
							navigate(routes.billing, {
								state: { openChangePlanModal: isTrialing }
							});
							handleClose();
						}}
						type="button"
					>
						{t('myDocuments.timerAction')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default ModalTimer;
